import { Helmet } from 'react-helmet-async';
import { Link } from 'react-router-dom';
import { Home, ArrowLeft } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { useConference } from '@/context/ConferenceContext';

const NotFound = () => {
  const { importantDetails, siteConfig } = useConference();
  return (
    <>
      <Helmet>
        <title>404 - Page Not Found | {importantDetails?.ConferenceTitle || siteConfig?.name || 'Conference'}</title>
      </Helmet>

      <div className="min-h-screen bg-white flex items-center justify-center">
        <div className="max-w-2xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <div className="mb-8">
            <h1 className="text-9xl font-bold text-sky-500 mb-4">404</h1>
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
              Page Not Found
            </h2>
            <p className="text-lg text-gray-600 mb-8">
              Sorry, we couldn't find the page you're looking for. The page might have been moved or doesn't exist.
            </p>
          </div>

          <div className="flex flex-wrap justify-center gap-4">
            <Link to="/">
              <Button className="bg-sky-500 hover:bg-sky-600" data-testid="go-home-btn">
                <Home size={18} className="mr-2" />
                Go to Homepage
              </Button>
            </Link>
            <Button
              variant="outline"
              onClick={() => window.history.back()}
              data-testid="go-back-btn"
            >
              <ArrowLeft size={18} className="mr-2" />
              Go Back
            </Button>
          </div>

          <div className="mt-12 grid grid-cols-2 md:grid-cols-4 gap-4 text-left">
            <Link to="/about" className="p-4 rounded-xl bg-gray-50 hover:bg-gray-100 transition-colors">
              <p className="font-semibold text-gray-900 text-sm">About</p>
              <p className="text-xs text-gray-600">Learn more</p>
            </Link>
            <Link to="/speakers" className="p-4 rounded-xl bg-gray-50 hover:bg-gray-100 transition-colors">
              <p className="font-semibold text-gray-900 text-sm">Speakers</p>
              <p className="text-xs text-gray-600">View lineup</p>
            </Link>
            <Link to="/schedule" className="p-4 rounded-xl bg-gray-50 hover:bg-gray-100 transition-colors">
              <p className="font-semibold text-gray-900 text-sm">Schedule</p>
              <p className="text-xs text-gray-600">See program</p>
            </Link>
            <Link to="/contact" className="p-4 rounded-xl bg-gray-50 hover:bg-gray-100 transition-colors">
              <p className="font-semibold text-gray-900 text-sm">Contact</p>
              <p className="text-xs text-gray-600">Get help</p>
            </Link>
          </div>
        </div>
      </div>
    </>
  );
};

export default NotFound;
